import EventEmitter from 'eventemitter3'

export type AppEvents = {
  'dataset:updated': { datasetId: string; version: string }
  'job:progress': { jobId: string; progress: number }
  'job:completed': { jobId: string; status: 'succeeded' | 'failed' }
  'symbol:selected': { symbol: string }
  'research:completed': { runId: string }
  'stock-pool:updated': { poolId: string; versionId?: string; jobId?: string }
  'paper:risk-raised': { accountId: string; message: string }
  'session:expired': undefined
}

class TypedBus extends EventEmitter<AppEvents> {
  emit<K extends keyof AppEvents>(event: K, payload: AppEvents[K]): boolean { return super.emit(event, payload) }
  on<K extends keyof AppEvents>(event: K, listener: (payload: AppEvents[K]) => void, context?: unknown): this { return super.on(event, listener as never, context) }
}

export const appBus = new TypedBus()
